{
    "DAYS": "dias",
    "HOURS": "horas",
    "MINUTES": "minutos",
    "SECONDS": "segundos",
    "STARTING_SOON": "Começando em breve...",
    "DEFAULT_ERROR": "Playback Error",
    "DEFAULT_ERROR_DESCRIPTION": "Não foi possível reproduzir o vídeo. Por favor, tente novamente mais tarde.",
    "API_ERROR": "Falha ao Recuperar Informações do Vídeo",
    "API_ERROR_DESCRIPTION": "Erro ao buscar detalhes do vídeo. Verifique seu videoId e conexão com a internet e tente novamente.",
    "ERROR_CODE_NOT_AUTHENTICATED": "Autorização",
    "ERROR_CODE_NOT_AUTHENTICATED_DESCRIPTION": "Você não tem permissão para reproduzir este vídeo.",
    "ERROR_CODE_GEO_BLOCKED": "Restrição de Geoblocking",
    "ERROR_CODE_GEO_BLOCKED_DESCRIPTION": "Desculpe, este vídeo não está disponível em sua região devido a restrições de geoblocking.",
    "ERROR_CODE_NOT_ENTITLED": "Não autorizado",
    "ERROR_CODE_NOT_ENTITLED_DESCRIPTION": "Desculpe, você não está autorizado a reproduzir este vídeo.",
    "ERROR_CODE_VPN_BLOCKED": "VPN BLOQUEADO",
    "ERROR_CODE_VPN_BLOCKED_DESCRIPTION": "Este vídeo não está disponível devido ao uso de uma VPN.",
    "ERROR_CODE_IP_CHANGED": "Mudança de Rede",
    "ERROR_CODE_IP_CHANGED_DESCRIPTION": "Você mudou de rede inesperadamente. Por favor, tente novamente.",
    "ERROR_CODE_VPN_DETECTED": "VPN Detectada",
    "ERROR_CODE_VPN_DETECTED_DESCRIPTION": "Detectamos uma VPN. Por favor, desative-a e tente novamente.",
    "ERROR_CODE_ANONYMOUS_PROXY": "Proxy Anônimo Detectado",
    "ERROR_CODE_ANONYMOUS_PROXY_DESCRIPTION": "Detectamos um proxy anônimo ou servidor. Por favor, desative-o e tente novamente."
}
